import MaintenanceIcon from '@assets/images/maintenance-icon.svg?react'
import './index.scss'

const ASMErrorScreen = () => {
    return (
        <div className="asm-error-screen">
            <h1>At-Bay Stance is offline for maintenance.</h1>
            <p>
                Sorry for the inconvenience, we know how valuable your time is.
            </p>
            <p>Please check back in a few minutes.</p>
            <MaintenanceIcon />
        </div>
    )
}

export default ASMErrorScreen
